import { render, staticRenderFns } from "./ProjectInq.vue?vue&type=template&id=10c7f224&"
import script from "./ProjectInq.vue?vue&type=script&lang=js&"
export * from "./ProjectInq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports